import React, { useRef } from "react";
import "./Testimonial.css";
import ZentriStudiosImg from "../../assets/testimonial/zentri.png";
import MohanRajendraImg from "../../assets/testimonial/mohan$Rajendra.png";
import RonnyRImg from "../../assets/testimonial/ronny.png";
import VikasImg from "../../assets/testimonial/vikas.png";

const testimonials = [
  {
    name: "Zentri Studios",
    image: ZentriStudiosImg,
    review:
      "StarlinkLab truly understands our needs and delivers exactly what we envision. Their patience, professionalism, and communication made the experience seamless.",
    stars: 5,
  },
  {
    name: "Mohan & Rajendra",
    image: MohanRajendraImg,
    review:
      "The illustrations captured the Marvel vibe perfectly. Creative, professional, and exactly what we needed. Highly recommend!",
    stars: 5,
  },
  {
    name: "Ronny R.",
    image: RonnyRImg,
    review:
      "StarlinkLab exceeded my expectations. Creative, detailed, and extremely professional. Highly recommended!",
    stars: 4,
  },
  {
    name: "Vikas Agarwal",
    image: VikasImg,
    review:
      "Flawless delivery and great understanding of our requirements. StarlinkLab nailed it!",
    stars: 5,
  },
];

const Testimonials = () => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    const { current } = scrollRef;
    if (current) {
      const scrollAmount = 320;
      current.scrollBy({ left: direction === "left" ? -scrollAmount : scrollAmount, behavior: "smooth" });
    }
  };

  return (
    <div className="testimonials-section">
                {/* <h5 className="industriesTitle">-- How Can We Help You?</h5> */}

      <h1 className="testimonialsTitle">Some of our Happy Clients</h1>
      <h5 className="testimonialSubTitle">What do people praise about Starlinklab</h5>
      <p className="testimonialSubTitle2">starlinklab being the best Web development company aim at providing a high quality of service in every phase of Client Relationship.</p>

      <div className="arrow-buttons">
        <button onClick={() => scroll("left")} className="arrow left">←</button>
        <button onClick={() => scroll("right")} className="arrow right">→</button>
      </div>

      <div className="testimonials-scroll" ref={scrollRef}>
        {testimonials.map((testimonial, index) => (
          <div className={`testimonial-card card-${index}`} key={index}>
            <img
              src={testimonial.image}
              alt={testimonial.name}
              className="client-img"
            />
            <h3 className="testimonialsUsername">{testimonial.name}</h3>
            <p className="testimonialsReview">{testimonial.review}</p>
            <div className="stars">{"⭐".repeat(testimonial.stars)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Testimonials;
